import { useEffect, useState } from "react";
import { BASE_URL } from "../services/api";

const needsStorageProxy = (raw) =>
  raw.includes("storage.googleapis.com") ||
  raw.includes("firebasestorage.googleapis.com");

export function useAuthenticatedImageSrc(projectImage, imageFailed) {
  const [displaySrc, setDisplaySrc] = useState("");

  useEffect(() => {
    let cancelled = false;
    const ref = { blobUrl: null };
    const raw = String(projectImage || "").trim();

    if (!raw || imageFailed) {
      setDisplaySrc("");
      return undefined;
    }

    if (raw.startsWith("blob:")) {
      setDisplaySrc(raw);
      return undefined;
    }

    if (needsStorageProxy(raw)) {
      (async () => {
        try {
          const res = await fetch(
            `${BASE_URL}/api/assets/image?url=${encodeURIComponent(raw)}`,
            {
              credentials: "include",
            }
          );
          if (!res.ok || cancelled) return;
          const blob = await res.blob();
          if (cancelled) return;
          const url = URL.createObjectURL(blob);
          ref.blobUrl = url;
          setDisplaySrc(url);
        } catch {
          if (!cancelled) setDisplaySrc("");
        }
      })();

      return () => {
        cancelled = true;
        if (ref.blobUrl) {
          URL.revokeObjectURL(ref.blobUrl);
          ref.blobUrl = null;
        }
        setDisplaySrc("");
      };
    }

    if (/^https?:\/\//i.test(raw)) {
      setDisplaySrc(raw);
    } else if (raw.startsWith("/")) {
      setDisplaySrc(`${BASE_URL}${raw}`);
    } else {
      setDisplaySrc(`${BASE_URL}/${raw}`);
    }

    return undefined;
  }, [projectImage, imageFailed]);

  return displaySrc;
}
